import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ToastType = 'success' | 'info' | 'warning' | 'error';

export interface ToastMessage {
  texto: string;
  tipo: ToastType;
  visivel: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private toastSubject = new BehaviorSubject<ToastMessage>({
    texto: '',
    tipo: 'info',
    visivel: false
  });

  toast$ = this.toastSubject.asObservable();

  show(texto: string, tipo: ToastType = 'info', tempo = 4500): void {
    this.toastSubject.next({ texto, tipo, visivel: true });

    setTimeout(() => {
      this.toastSubject.next({ texto: '', tipo, visivel: false });
    }, tempo);
  }
}
